import React, { Component } from "react";

export default class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      // change state on parent level
      this.props.toggleModalState();
    }
  }

  renderContent() {
    return (
      <div className="gray-bg">
        <div ref={this.setWrapperRef} className="modal-box">
          <h1 className="modal-title">{this.props.title}</h1>
          <p className="modal-description">{this.props.description}</p>
          <p className="modal-description" style={{ color: "#D2232A" }}>
            {this.props.help}
          </p>

          {this.props.customComponent ? this.props.customComponent : null}
          {this.props.modalState === 2 ? (
            <div className="button-container">
              <button
                className="cancel-button"
                type="button"
                onClick={this.props.toggleModalState}
              >
                CANCEL
              </button>
              <button
                className="confirm-button"
                disabled={this.props.disableConfirm || false}
                style={
                  this.props.disableConfirm === true
                    ? { background: "grey", cursor: "not-allowed" }
                    : null
                }
                type="button"
                onClick={this.props.confirmFunction}
              >
                CONFIRM
              </button>
            </div>
          ) : (
            <button
              className="cancel-button"
              type="button"
              onClick={this.props.toggleModalState}
            >
              CLOSE
            </button>
          )}
        </div>
      </div>
    );
  }

  render() {
    return this.props.show === true ? this.renderContent() : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal.js